// import store from 'cmn-utils/lib/store';
import storage from "@/utils/storage"
import axios from "axios";
import {Toast} from "vant"
import {isWechat} from "./utils/tool";
import router from "./router";

export const clientVersion = "V1.0.3.20221125"; // 程序版本


export const baseUrl = `${window.location.protocol}//${location.host}/iotapp-api` // 应用平台
export const wxBaseUrl = `${window.location.protocol}//${location.host}/wechat-api` // 公众号转发
export const videoUrl = `${window.location.protocol}//${location.host}/video-api` // 视频播放
export const playerUrl = 'http://se.tokiot.cn/#/player/' // 视频播放器地址  这个似乎没用到

// export const getWSUrl = (userName) => `ws://${location.host}/iotapp-api/ws/${userName}/web`
export const getWSUrl = (userName) => `${window.location.protocol.startsWith('https')?'wss':'ws'}://se.api.tokiot.cn/ws/${userName}`

// 高德地图WEBkey
export const serviceKey = '2a2f98ddabc8f8aaf8a2ea950c23cd31'


// 查看图片
export const downloadImg = baseUrl + '/api/other/download-image-stream?fileId='


//返回状态判断
const afterResponse = (response, url) => {
    const {code, body, message} = response
    if (!code) return response
    if (code === 'OK') {
        return body !== null ? body : true
    } else if (code === 'PERMISSION_DENIED') {
        router.replace("/account/bind");
        return null
    } else if (code === 'UNAUTHORIZED') {
        router.replace("/account/bind");
        return null
    } else if (code === 'NOT_FOUND') {
        return null
        // return response
    } else if (code === "FAILED") {
        Toast.fail(message);
        console.error('请求失败了', response, url)
        return null
    } else {
        Toast.fail(message);
        // throw new Error(message)
    }
}
const errorHandle = err => {
    // 请求错误全局拦截
    if (err.name === 'RequestError') {
        Toast.fail('网络异常，请稍后重试。');
    }
}

export default {
    request: {
        prefix: isWechat() ? '' : baseUrl,
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        // 每次请求头部都会带着这些参数
        withHeaders: () => {
            const headers = storage.getCache('headers')
            return headers
        },
        beforeRequest: (url, config, a) => {
            // if (isWechat()&&"POST"==config.method) {
            //     config.headers={'content-type': 'application/x-www-form-urlencoded'}
            // }
        },
        credentials: 'omit',
        afterResponse,
        errorHandle,
    }
}


axios.defaults.timeout = 5000;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

axios.defaults.baseURL = wxBaseUrl;
axios.interceptors.response.use(afterResponse, errorHandle)
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// axios.defaults.headers.get['Access-Token'] = 'oR-WQwPOWJB9E87vhGOYXkyCGhSU';


export function wxGet(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, params)
            .then(
                response => {
                    resolve(response);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });
    });
}

export function wxPost(url, params) {
    console.error('微信post请求', url, params)
    return new Promise((resolve, reject) => {
        axios
            .post(url, params)
            .then(ret => {
                    console.info('post请求结果', ret)
                }
            )
            .catch(error => {
                console.info("请求地址出错", url, error);
                reject(error);
            });
    });
}